import { render, staticRenderFns } from "./AiResponseForUserMessage.vue?vue&type=template&id=1b9465de&scoped=true"
import script from "./AiResponseForUserMessage.vue?vue&type=script&lang=ts"
export * from "./AiResponseForUserMessage.vue?vue&type=script&lang=ts"
import style0 from "./AiResponseForUserMessage.vue?vue&type=style&index=0&id=1b9465de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9465de",
  null
  
)

export default component.exports